import styled from 'styled-components';
import { toRem } from '@marriott/shared/mi-helper-utils';
import { MControlTabScrollDirection } from './MControlTabScroll.types';

type WrapperProps = {
  $direction: MControlTabScrollDirection;
};

export const getJustifyContent = (direction: MControlTabScrollDirection) =>
  direction === MControlTabScrollDirection.Left ? 'flex-start' : 'flex-end';

const LTR_GRADIENT: Record<MControlTabScrollDirection, string> = {
  [MControlTabScrollDirection.Left]: '270deg',
  [MControlTabScrollDirection.Right]: '90deg',
};

const RTL_GRADIENT: Record<MControlTabScrollDirection, string> = {
  [MControlTabScrollDirection.Left]: '90deg',
  [MControlTabScrollDirection.Right]: '270deg',
};

const buildGradient = (angle: string) =>
  `linear-gradient(${angle}, rgba(var(--t-brand-bg-color-rgb), 0) 0%, var(--t-brand-bg-color) 100%)`;

export const Wrapper = styled.button<WrapperProps>`
  margin: 0;
  padding: 0;
  border: none;
  display: flex;
  align-items: center;
  width: ${toRem(80)};
  min-width: ${toRem(80)};
  height: 100%;
  cursor: pointer;
  justify-content: ${props => getJustifyContent(props.$direction)};
  background: ${props => buildGradient(LTR_GRADIENT[props.$direction])};
  position: relative;
  z-index: 2;

  [dir='rtl'] & {
    background: ${props => buildGradient(RTL_GRADIENT[props.$direction])};
  }

  &:focus-visible {
    outline: -webkit-focus-ring-color auto 1px;
  }
`;

export const IconWrapper = styled.div<{ $direction: MControlTabScrollDirection }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t-color-control-foreground-reverse);
`;
